import { genGetLabel, genHtmlOptions, genMenuItems } from "../utils";

export const getPreviousLinkFileOrTextState = (item) => {
    if (item?.attachment) {
        return 'file';
    }
    if (item?.url) {
        return 'link';
    }
    if (item?.text) {
        return 'text';
    }
};


// CP-6187: a trip item's Friendly Name is what guests see in the app in place of its Name, which stays the
// dashboard's. The app row is as narrow as the Name's, so it gets the Name's 64-character limit.
export const FRIENDLY_NAME_MAX_LENGTH = 64;
export const FRIENDLY_NAME_HELP = 'Guests see this name in the app instead of the Name. Leave it blank to show the Name.';

// The line shown under a trip item's Name where staff compare it with the app (the phone list rows, a trip's
// Trip Items tab): the Friendly Name guests see in its place. None when it is blank: the app shows the Name.
export const guestsSeeText = (item) => (item?.friendly_name?.trim() ? `Guests see: ${item.friendly_name}` : null);

export const RENDERING_TYPES = {};
export const RENDERING_TYPE_TEXT = 1;
export const RENDERING_TYPE_CHECKBOXES = 2;
export const RENDERING_TYPE_LINK = 3;
export const RENDERING_TYPE_LIST = 4;
RENDERING_TYPES[RENDERING_TYPE_TEXT] = "Text";
RENDERING_TYPES[RENDERING_TYPE_CHECKBOXES] = "List with Checkboxes";
RENDERING_TYPES[RENDERING_TYPE_LINK] = "Link";
RENDERING_TYPES[RENDERING_TYPE_LIST] = "List";

export const renderingTypeLabel = genGetLabel(RENDERING_TYPES);
export const renderingTypesMenuItems = genMenuItems(RENDERING_TYPES);
export const renderingTypesHtmlMenuItems = genHtmlOptions(RENDERING_TYPES);

export const ConfirmationDialogText = {
    "delete_pretrip_item": { title: "Please confirm", body: "Do you really want to delete this trip item?", okButtonText: "Delete", cancelButtonText: "Cancel" },
    "delete_pretrip_items": { title: "Please confirm", body: "Do you really want to delete these trip items?", okButtonText: "Delete", cancelButtonText: "Cancel" },
    "delete_pretrip_category": { title: "Please confirm", body: "Do you really want to delete this trip item category?", okButtonText: "Delete", cancelButtonText: "Cancel" },
    "delete_pretrip_categories": { title: "Please confirm", body: "Do you really want to delete these trip item categories?", okButtonText: "Delete", cancelButtonText: "Cancel" },
}
